import { render, staticRenderFns } from "./BienDetailsMap.vue?vue&type=template&id=12787ac2&scoped=true"
import script from "./BienDetailsMap.vue?vue&type=script&lang=js"
export * from "./BienDetailsMap.vue?vue&type=script&lang=js"
import style0 from "./BienDetailsMap.vue?vue&type=style&index=0&id=12787ac2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12787ac2",
  null
  
)

export default component.exports